import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiAxios } from '@/lib/apiAxios';
const saveAsTemplate = async ({ workspaceId, ...body }) => {
    const response = await apiAxios.post(`/workspaces/${workspaceId}/campaign-templates`, body);
    return response.data;
};
export const useSaveAsTemplate = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: saveAsTemplate,
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['campaign-templates', 'workspace', variables.workspaceId] });
        },
    });
};
const deleteWorkspaceTemplate = async ({ workspaceId, publicId, }) => {
    const response = await apiAxios.delete(`/workspaces/${workspaceId}/campaign-templates/${publicId}`);
    return response.data;
};
export const useDeleteWorkspaceTemplate = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteWorkspaceTemplate,
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['campaign-templates', 'workspace', variables.workspaceId] });
        },
    });
};
